import { ProjectModel } from '../../models/Project';
import {LIST_PROJECT_TYPE} from './../type/index';

export const changeProjectList = (data: ProjectModel[]) => ({
  type: LIST_PROJECT_TYPE.CHANGE_LIST,
  payload: data,
})
